import React from 'react';
import pt from 'prop-types';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import HomeSection from '../../components/home/HomeSection';
import styled from 'styled-components';
import {useStore} from '../../stores';

const Section = styled.div`
    &&& {
        padding: 0;
    }
`;

const Container = styled.div`
    overflow: hidden;
    background: rgb(211, 211, 211);
    background: linear-gradient(to bottom, #252525 0%, #565656 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#252525', endColorstr='#565656',GradientType=0 );
    ${props =>
        props.loading
            ? `
        .row > div:nth-child(1) > a{
            background: #1d1d1d;
        }
        .row > div:nth-child(2) > a{
            background: #222;
        }
        .row > div:nth-child(3) > a{
            background: #303030;
        }
        `
            : ''}
`;

const HomeContainer = ({pageData = {}}) => {
    const sectionList = pageData.sectionList || {};
    const sections = sectionList.sections || [];
    const [{loading}] = useStore();
    const items = sections.map(item => {
        const {title} = item;
        return (
            <Section key={`section-${title}`} className="col-xs-12 col-md-4">
                <HomeSection {...item} />
            </Section>
        );
    });

    if (loading) {
        for (let i = 0; i < 3; i++) {
            items.push(
                <Section key={`section-${i}`} className="col-xs-12 col-md-4">
                    <HomeSection {...{}} />
                </Section>
            );
        }
    }

    return (
        <Container loading={loading}>
            {getHelmetForMetaTags(pageData)}
            <div className="row">{items}</div>
        </Container>
    );
};

HomeContainer.propTypes = {
    pageData: pt.object
};

export default HomeContainer;
